export enum UserServiceKeyStatus{
    NoKey = "No Key",
    ExpiredKey = "Key Expired",
    ValidKey = "Valid Key"   
}